// CRA inlines REACT_APP_* at build time. Operators set REACT_APP_BUILD_STAMP
// on the glass-pwa Hosting bake (same role as admin VITE_BUILD_STAMP).
// Three-host Live jobs / DEMO entry unify (#197). Shared with admin + shop.
export const FALLBACK_BUILD_STAMP = 'glass-live-jobs-entry-unified-20260915';

export const BUILD_STAMP = process.env.REACT_APP_BUILD_STAMP || FALLBACK_BUILD_STAMP;

export const BUILD_STAMP_HINT = 'Hard refresh if UI looks stale · Cmd/Ctrl+Shift+R';
